import { useState, useEffect, Key } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/ScmTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { globalPrompt } from "@/components/message";
import { IMaterialDetail, IMaterialSearchFields, materialService } from "../../../../base/material/materialService"
import { IPurchasePlanFields, IDetailList } from "../../purchasePlanType"
import { purchasePlanService } from "../../purchasePlanService"
import { transPgToPagination, formatNum, IsUseDefaultBentity } from "@/utils/utils";
import useGlobalModel from "@/model/globalModel";
import { IVRMshelfDetail } from "@/views/base/warehouse/warehouseTypes";
import { convertRes2Blob } from "@/utils/exportFile";
import { DictCodeEnmu, sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import { IStockStatisticDetail } from "@/views/stock/statistic/stockStatisticService";
import { useLockFn } from "ahooks";
import { message } from "antd";
import { warehouseService } from "@/views/base/warehouse/warehouseService";

export type IVrmPlanDescType = {
    numAll: number,
    itemNumAll: number,
    totalAll: number,
    [key: string]: any
}
//这里为了继承一个弹框列表的自定义属性值
export interface IMaterialDetailModel extends IMaterialDetail {
    num: number,
    amount: number,
    arrivedNum?: number,    // 0,
    arrivedTotal?: number,    // 0,
    unarrivedNum?: number,    // 0,
    planNum?: number
    minNum?: number,
}
export const usePurchasePlanDetailsModel = createModel(function () {
    const { user, shopAndOrg, beShopDs } = useGlobalModel()
    const { shopId, shopName } = shopAndOrg
    const { warehouseList, user: { roles } } = useGlobalModel();
    const [addModalVisible, setAddModalVisible] = useState<boolean>(false)  //新增商品弹框
    const [supMore, setSupMore] = useState<boolean>(true);  //控制更多按钮
    const [more, setMore] = useState<boolean>(true);  //控制更多按钮
    const initDesc = {
        numAll: 0,  //数量
        itemNumAll: 0, //项数
        totalAll: 0 //总计
    }
    const initForm = {
        shopId, shopName,
        // bentityCode: IsUseDefaultBentity(shopId) ? DictCodeEnmu.BENTITY_BJ_YH_AUTO_SERVICE : "",
        // bentityName: IsUseDefaultBentity(shopId) ? beShopDs.find(item => item.value === DictCodeEnmu.BENTITY_BJ_YH_AUTO_SERVICE)?.label : "", 
        bentityName: beShopDs.find((item: any) => item.value === "bentity.hd")?.label ?? "",
        bentityCode: "bentity.hd",
    }
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initSearchParam: IMaterialSearchFields = {};
    //新增数据
    //新增详情form
    const [detailAddForm, setDetailAddForm] = useState<IPurchasePlanFields>(initForm)
    //新增详情列表
    const [detailAddList, setDetailAddList] = useState<IDetailList[]>([])
    //新增详情列表选中行
    const [detaiAddDataRowKeys, setDetaiAddDataRowKeys] = useState<Key[]>([]);
    const [detaiAddDataRow, setDetaiAddDataRow] = useState<IDetailList[]>([]);
    const [addDesc, setAddDesc] = useState<IVrmPlanDescType>(initDesc)
    const [warehouseData, setWarehouseData] = useState<any>({
        add: warehouseList,
        edit: [],
        look: []
    });
    //查看数据
    //查看详情form
    const [detailLookForm, setDetailLookForm] = useState<IPurchasePlanFields>({})
    //查看详情列表
    const [detailLookList, setDetailLookList] = useState<IDetailList[]>([])
    const [lookDesc, setLookDesc] = useState<IVrmPlanDescType>(initDesc)

    //详情数据
    //详情列表参数
    const [detailDataSource, setDetailDataSource] = useState<IDetailList[]>([]);
    //详情表格选中行
    const [detailDataRowKeys, setDetailDataRowKeys] = useState<Key[]>([]);
    const [detailDataRow, setDetailDataRow] = useState<IDetailList[]>([]);
    const [detailEditForm, setDetailEditForm] = useState<IPurchasePlanFields>({})
    const [editDesc, setEditDesc] = useState<IVrmPlanDescType>(initDesc)

    //配件列表配置
    const [workDataSource, setWorkDataSource] = useState<IMaterialDetailModel[]>([])
    const [searchWorkData, setSearchWorkData] = useState<IMaterialSearchFields>(initSearchParam)
    const [workPgCfg, setWorkPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //已选配件列表
    const [addDataSource, setAddDataSource] = useState<IMaterialDetailModel[]>([]);
    const [saveLoading, setSaveLoading] = useState<boolean>(false); //  保存按钮
    //表单改变或表格数据发生改变时，控制功能按钮的启用禁用
    const [topButsControl, setTopButsControl] = useState<boolean>(false)
    const typeForm: any = {
        add: { ...detailAddForm },
        edit: detailEditForm,
        look: detailLookForm
    }
    //设置底部总数展示（查看|编辑|查看）
    useEffect(() => {
        let newDesc: IVrmPlanDescType = initDesc;
        let newList = detailDataSource.filter(item => item.deleteFlag !== 1)
        newList && newList.forEach(item => {
            newDesc.numAll += Number(item.planNum);
            newDesc.totalAll += Number(item.price) * Number(item.planNum);
        });
        newDesc.itemNumAll = newList && newList.length
        setEditDesc(newDesc);
    }, [detailDataSource])

    useEffect(() => {
        let newDesc: IVrmPlanDescType = initDesc;
        let newList = detailAddList.filter(item => item.deleteFlag !== 1)
        newList && newList.forEach(item => {
            newDesc.numAll += Number(item.planNum);
            newDesc.totalAll += Number(item.planNum) * Number(item.price);
        });
        newDesc.itemNumAll = newList && newList.length
        setAddDesc(newDesc);
    }, [detailAddList])

    useEffect(() => {
        let newDesc: IVrmPlanDescType = initDesc;
        let newList = detailLookList.filter(item => item.deleteFlag !== 1)
        newList && newList.forEach(item => {
            newDesc.numAll += Number(item.planNum);
            newDesc.totalAll += Number(item.planNum) * Number(item.price);
        });
        newDesc.itemNumAll = newList && newList.length
        setLookDesc(newDesc);
    }, [detailLookList])
    useEffect(() => {
        setDetailAddForm({ ...initForm, shopId, shopName });
    }, [shopId])
    //新增表单缓存
    const updateAddFormVal = (val: IPurchasePlanFields) => {
        let newVal = val
        setDetailAddForm({ ...detailAddForm, ...newVal })
    }
    //编辑表单缓存
    const updatEditFormVal = (val: IPurchasePlanFields) => {
        let newVal = val
        setDetailEditForm({ ...detailEditForm, ...newVal })
    }
    //获取一条编辑或查看数据
    const getDetailEditOne = async (id: string, pattern: string) => {
        let { retData } = await purchasePlanService.one(id);
        // return console.log(retData)
        const { details, ...from } = retData
        if (retData) {
            let fileList: any = []
            const { md5, fileName } = from
            if (md5) {
                fileList = [
                    {
                        uid: md5,
                        status: 'done',
                        name: fileName,
                        response: {
                            retData: md5,
                        },
                    },
                ]
            }
            const params = {
                pageSize: 10000,
                pageNum: 1,
                shopId: from.shopId,
            }
            let { retData } = await warehouseService.page(params);
            const { records, ...pg } = retData;
            from.fileList = fileList
            let newList: any = details ? details.map((item) => { return { ...item, detailsId: item.id } }) : []
            if (pattern === "edit") {
                setWarehouseData({ ...warehouseData, edit: records })
                setDetailDataSource(newList ?? [])
                setDetailEditForm(from)
                setTopButsControl(false)
            } else if (pattern === "look") {
                setWarehouseData({ ...warehouseData, look: records })
                setDetailLookForm(from);
                setDetailLookList(newList ?? [])
            }
        }
    }
    //关闭弹框
    const resetWorkloadData = async () => {
        setSearchWorkData({});
        workloadData(initPgCfg, {});
    }
    const [addLoading, setAddLoading] = useState<boolean>(false)
    //加载配件数据
    const workloadData = async (page?: ISearchPage, searchValue: IMaterialSearchFields = searchWorkData) => {
        setAddLoading(true)
        const searchParams = {
            ...searchValue,
            ...shopAndOrg,
            ...sourceAppOrBranch,
            pageSize: page?.pageSize ?? workPgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? workPgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await materialService.page(searchParams);
        const { records, ...pg } = retData;
        const newRecords = records.map((item) => {
            let { latestPurPrice, purchasePrice, materialDetal, materialShelfVo } = item
            let materialOne = (materialDetal ?? [])[0]
            materialShelfVo = materialShelfVo ?? {}
            //取最近采购价格，没有的话取档案进货价
            // let newPurchasePrice = latestPurPrice ? latestPurPrice : purchasePrice ?? 0
            let newPurchasePrice = purchasePrice ?? 0
            return {
                ...item,
                num: 1,
                purchasePrice: newPurchasePrice,
                amount: newPurchasePrice * 1,
                // icon: materialDetal && materialDetal?.length !== 0 && materialDetal?.length !== 1 ? 1 : 0,
                warehouseCode: '',
                warehouseName: '',
                shelfCode: '',
                shelfId: '',
            }
        })
        setWorkPgCfg(transPgToPagination(pg));
        setWorkDataSource(newRecords);
        setAddLoading(false)
    }
    //筛选模块详情 详情和新增的列表已有数据的方法
    const modelScreenMethod = async (modelList: IMaterialDetailModel[], detailList: IDetailList[], mode: string, type: string) => {
        console.log(modelList, detailList)
        const repetition: string[] = [];
        // const newDetailData: IMaterialDetailModel[] = []
        const newDetailData: any[] = [...detailList]
        const detailForm: any = mode === "add" ? detailAddForm : mode === "edit" ? detailEditForm : detailLookForm;
        let newData = type == 'add' ? await transferwarehouseList(modelList, detailForm.purchaseTypeCode, mode) : []
        modelList.forEach(Item => {
            let isSelect = newDetailData.find(item => item.materialCode === (Item.materialCode ?? Item.code));
            if (isSelect === undefined) {
                let data = newData.find((list: any) => list.materialCode === (Item.materialCode ?? Item.code))
                newDetailData.push({
                    ...Item,
                    ...data,
                    arrivedTotal: 0,
                    unarrivedNum: 0,
                    planNum: Item.num,
                    num: 0,
                    minNum: Item.minOrderNum,
                    materialCode: Item.materialCode ?? Item.code,
                    materialName: Item.materialName ?? Item.name,
                    price: Item.purchasePrice ?? Item.price,
                    detailsId: Item.id,
                    id: "",
                });
            } else {
                repetition.push(`【${Item.materialName ?? Item.name} (${Item.materialCode ?? Item.code})】`);
            }
        })
        return { newDetailData, repetition }
    }
    //添加到详情列表
    const transformsToPoDetailList = async (mode: string) => {
        //添加列表
        if (mode === "add") {
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailAddList, mode, 'add')
            setDetailAddList(newDetailData)
            repetition.length != 0 && globalPrompt("message", { text: `${repetition.join(",")}，以上重复配件已过滤。`, type: "warning" });

        } else if (mode === "edit") {
            //详情列表
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailDataSource, mode, 'add')
            setDetailDataSource(newDetailData)
            repetition.length != 0 && globalPrompt("message", { text: `${repetition.join(",")}，以上重复配件已过滤。`, type: "warning" });

        }
    }
    //添加到详情列表
    const transferwarehouseList = async (list: any, value: string, mode: string,) => {
        const repetition = list.map((item: any) => item.materialCode ?? item.code);
        let { retData } = await purchasePlanService.findTransferwarehouse({
            shopId: typeForm[mode].shopId,
            materialCodes: repetition,
            direct: value
        });
        return list.map((item: any) => {
            let newData = retData.find((list: any) => list.materialCode === (item.materialCode ?? item.code))
            return {
                ...item,
                ...newData,
                shelfCode: newData?.shelfCode ?? '',
                shelfId: newData?.shelfId ?? '',
                warehouseCode: newData?.warehouseCode ?? '',
                warehouseName: newData?.warehouseName ?? '',
                isPurShelf: newData?.warehouseCode ? true : false
            }
        })
    }
    //删除详情列表数据
    const detailDetailList = async (mode: string, Material?: IDetailList) => {
        if (mode === "add") {
            // const filterDetailList = detailAddList.filter(el => !!!detaiAddDataRowKeys.find(ele => ele === el.materialCode));
            const filterDetailList = Material ? detailAddList.filter(el => !!!(Material.detailsId === el.detailsId)) : detailAddList.filter(el => !!!detaiAddDataRowKeys.find(ele => ele === el.detailsId));
            setDetailAddList(filterDetailList)
            globalPrompt("message", { text: `删除成功`, type: "success" });
            setDetaiAddDataRowKeys([]);
            setDetaiAddDataRow([]);
        } else if (mode === "edit") {
            globalPrompt("modal", {
                title: `确定作废${Material ? Material.materialName : detailDataSource.filter(el => detailDataRowKeys.find(ele => ele === el.detailsId)).map((item: any) => item.materialName)}吗？`,
                type: "success",
                text: "",
                okText: "确定",
                onOk: async () => {
                    const backendDetailList: any = Material ? Material.id ? [{ id: Material.id }] : [] : detailDataRow.reduce((all, next) => {  //前端页面维护的需要删除的id
                        if (next.id) {
                            all.push({ id: next.id });
                        }
                        return all;
                    }, []);

                    //删除详情列表调用的方法
                    const deleteData = () => {
                        // const filterDetailList = Material ? detailDataSource.filter(el => !!!(Material.materialCode === el.materialCode)) : detailDataSource.filter(el => !!!detailDataRowKeys.find(ele => ele === el.materialCode));
                        const filterDetailList = Material ? detailDataSource.map(el => {
                            if (Material.detailsId === el.detailsId) {
                                return { ...el, deleteFlag: 1 }
                            } else {
                                return el
                            }
                        }) : detailDataSource.map(el => {
                            if (detailDataRowKeys.find(ele => ele === el.detailsId)) {
                                return { ...el, deleteFlag: 1 }
                            } else {
                                return el
                            }
                        });

                        setDetailDataSource(filterDetailList)
                        globalPrompt("message", { text: `删除成功`, type: "success" });
                        setDetailDataRowKeys([]);
                        setDetailDataRow([]);
                    }

                    if (backendDetailList.length > 0) {
                        await purchasePlanService.materialDelete({ ids: backendDetailList, planCode: detailEditForm.planCode as string }).then(res => {
                            if (res.retData) {
                                deleteData()
                            } else {
                                globalPrompt("message", { text: `删除失败`, type: "success" });
                            }
                        })
                    } else {
                        deleteData()
                    }
                },
                cancelText: "取消",
                onCancel: () => {
                }
            })
        }
    }
    //表单计算校验 (计算主单信息与配件每一项)
    const formComputeRule = (mode: string): boolean => {
        let goods = mode === "edit" ? detailDataSource.filter(item => item.deleteFlag !== 1) : detailAddList;

        let { totalAll } = mode === "edit" ? editDesc : addDesc;

        totalAll = +formatNum(totalAll);//采购总金额

        let goodsTotal: number = 0;
        goods.forEach(item => {
            let { amount } = item as { amount: number }
            goodsTotal += amount
        })
        if (+formatNum(goodsTotal) !== totalAll) {
            message.warning(`详情采购总金额${+formatNum(goodsTotal)}与表单采购总金额不符`);
            return false;
        }
        let goodsNoNum = goods.filter(item => (item.planNum as number) < 0 || (item.price as number) < 0).map(list => list.materialCode)
        if (goodsNoNum.length > 0) {
            message.warning(`详情${goodsNoNum}的采购数量或采购单价不可小于0！`);
            return false;
        }
        return true
    }
    //新增采购单
    const insertDetail = useLockFn(async (params: IPurchasePlanFields) => {
        try {
            let newParams = {
                ...params,
                details: detailAddList,
                createUser: user.username,
                // ...shopAndOrg,
                ...sourceAppOrBranch,
            }
            setSaveLoading(true)
            let { retData } = await purchasePlanService.insert(newParams);
            setSaveLoading(false)
            return retData;
        } catch (error) {
            setSaveLoading(false)
        }
    })
    //编辑采购单
    const editDetail = useLockFn(async (params: IPurchasePlanFields) => {
        try {
            let newParams = {
                ...params,
                details: detailDataSource,
                updateUser: user.username,
                // ...shopAndOrg,
                ...sourceAppOrBranch,
            }
            setSaveLoading(true)
            let { retData } = await purchasePlanService.update(newParams);
            setSaveLoading(false)
            return retData;
        } catch (error) {
            setSaveLoading(false)
        }
    })
    //关闭页签清不同状态缓存
    const resetAddCatch = async (type: string) => {
        setDetailAddForm(initForm)
        setDetailAddList([]);
    }
    const resetEditCatch = async (type: string) => {
        setDetailEditForm({});
        setDetailDataSource([]);
    }
    const downloadTpl = async () => {
        let result = await purchasePlanService.downloadTpl();
        convertRes2Blob(result)
    }
    const arrivalExport = async () => {
        let result = await purchasePlanService.arrivalExport(detailEditForm.planCode);
        convertRes2Blob(result)
    }
    const Transfer = useLockFn(async () => {
        let { retData } = await purchasePlanService.transfer(detailEditForm.planCode as string);
        return retData
    })
    const [historyVisible, setHistoryVisible] = useState<boolean>(false)
    const [historyRow, setHistoryRow] = useState<IStockStatisticDetail>({})
    const [supplierHistoryVisible, setSupplierHistoryVisible] = useState<boolean>(false) //消费记录展示
    const [supplierHistoryModel, setSupplierHistoryModel] = useState<{ supplierName: string }>({ supplierName: "" }) //消费记录参数
    return {
        addModalVisible, addLoading,
        initPgCfg,
        detailAddForm,
        detailAddList,
        detaiAddDataRow,
        addDesc,
        detailLookForm,
        detailLookList,
        lookDesc,
        detailDataSource,
        detailDataRowKeys,
        detailDataRow,
        detailEditForm,
        editDesc,
        workDataSource,
        searchWorkData,
        workPgCfg,
        addDataSource,
        detaiAddDataRowKeys,
        setAddModalVisible,
        setDetailAddForm,
        setDetailAddList,
        setDetaiAddDataRow,
        setAddDesc,
        setDetailLookForm,
        setDetailLookList,
        setLookDesc,
        setDetailDataSource,
        setDetailDataRowKeys,
        setDetailDataRow,
        setDetailEditForm,
        setEditDesc,
        setWorkDataSource,
        setSearchWorkData,
        setWorkPgCfg,
        setAddDataSource,
        updateAddFormVal,
        updatEditFormVal,
        getDetailEditOne,
        resetWorkloadData,
        workloadData,
        transformsToPoDetailList,
        detailDetailList,
        insertDetail,
        editDetail,
        resetAddCatch,
        resetEditCatch,
        setDetaiAddDataRowKeys,
        downloadTpl,
        modelScreenMethod,
        Transfer,
        initForm,
        topButsControl, setTopButsControl,
        historyVisible, setHistoryVisible,
        historyRow, setHistoryRow,
        supplierHistoryVisible, setSupplierHistoryVisible,
        supplierHistoryModel, setSupplierHistoryModel,
        formComputeRule,
        saveLoading, setSaveLoading, arrivalExport,
        warehouseData, setWarehouseData, transferwarehouseList,
        supMore, setSupMore,
        more, setMore
    }
})